// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__Aq0MF","relative":"SpinnerButton_relative__T55qR","hideText":"SpinnerButton_hideText__wZzER"};